import { defineMessages } from 'react-intl';

export default defineMessages({
  completeOrder: {
    id: 'components.CompleteOrderButton.completeOrder',
    description: 'Complete order text',
    defaultMessage: 'Place Order',
  },
  privacyText: {
    id: 'components.CompleteOrderButton.privacyText',
    description: 'Privancy Policy details',
    defaultMessage:
      'By submitting your order, you confirm you are 18 years of age and agree to our',
  },
  termsOfUse: {
    id: 'components.CompleteOrderButton.termsOfUse',
    description: 'privacy policy terms of use',
    defaultMessage: 'terms of use',
  },
  privacyPlicyText: {
    id: 'components.CompleteOrderButton.privacyPlicyText',
    description: 'privacy policy',
    defaultMessage: 'privacy policy',
  },
  privacyConnector: {
    id: 'components.CompleteOrderButton.privacyConnector',
    description: 'privacy policy text connector',
    defaultMessage: 'and',
  },
});
